export default "__VITE_ASSET__CtV4UYQZ__"